import { render, staticRenderFns } from "./TableSettings.vue?vue&type=template&id=5826e448&scoped=true"
import script from "./TableSettings.vue?vue&type=script&lang=js"
export * from "./TableSettings.vue?vue&type=script&lang=js"
import style0 from "./TableSettings.vue?vue&type=style&index=0&id=5826e448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5826e448",
  null
  
)

export default component.exports